import { type ReactElement } from "react";

type TProps = {
  children: ReactElement;
};

// Adding this here in case in the future we want to add
// public route specific logic - J
export function PublicRoute({ children }: TProps) {
  return children;
}
